import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const PresaleForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    quantity: "",
    telegram: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // Loader state

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loader

    try {
      const res = await fetch(
        "https://d2l873mxalz3b9.cloudfront.net/send-email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: `${formData.firstName} ${formData.lastName}`,
            email: formData.email,
            message: `
Mobile No: ${formData.mobile}
Token Quantity: ${formData.quantity}
Telegram ID: ${formData.telegram}
          `,
          }),
        }
      );

      const result = await res.json();
      if (result.success) {
        setSubmitted(true);
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        alert("Failed to send form.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred.");
    } finally {
      setLoading(false); // Stop loader
    }
  };

  // ---------- STYLES ----------
  const containerStyle = {
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#030b15",
    padding: "20px",
  };

  const formWrapperStyle = {
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    maxWidth: "600px",
    width: "100%",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontWeight: "600",
    color: "#333",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    marginBottom: "20px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "16px",
  };

  const spinnerStyle = {
    width: "20px",
    height: "20px",
    border: "2px solid #fff",
    borderTop: "2px solid transparent",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    margin: "0 auto",
  };

  const titleStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "30px",
    textAlign: "center",
    color: "#111827",
  };

  const rowStyle = {
    display: "flex",
    gap: "16px",
  };

  const halfInputStyle = {
    ...inputStyle,
    flex: 1,
  };

  const headingBlockStyle = {
    textAlign: "center",
    maxWidth: "700px",
    marginBottom: "20px",
  };

  const headingTextStyle = {
    fontSize: "24px",
    fontWeight: "700",
    color: "#fff",
    marginBottom: "10px",
  };

  const subTextStyle = {
    fontSize: "16px",
    color: "#fff",
    fontFamily: "Merriweather Sans",
  };

  const successScreenStyle = {
    textAlign: "center",
    backgroundColor: "#ffffff",
    padding: "60px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  };

  const successIconStyle = {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "#10b981",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
    marginBottom: "20px",
  };

  const checkMarkStyle = {
    color: "white",
    fontSize: "36px",
    fontWeight: "bold",
  };

  const successTitleStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#10b981",
  };

  const successTextStyle = {
    fontSize: "14px",
    color: "#6b7280",
  };

  return (
    <div style={containerStyle}>
      {!submitted && (
        <div style={headingBlockStyle}>
          <h1 style={headingTextStyle} className="mt-4 mb-4">
            Join the DIAG Token Presale and be part of the healthcare
            revolution.
          </h1>
          <p style={subTextStyle}>
            Fill in your details, and our team will contact you via email with
            the next steps and the presale agreement.
          </p>
        </div>
      )}

      {submitted ? (
        <div style={successScreenStyle}>
          <div style={successIconStyle}>
            <span style={checkMarkStyle}>✓</span>
          </div>
          <div style={successTitleStyle}>Successful!</div>
          <p style={successTextStyle}>
            Thank you! We’ve received your submission. You’ll hear from our team
            soon.
          </p>
        </div>
      ) : (
        <div style={formWrapperStyle}>
          <h2 style={titleStyle}>Diag Token Presale Form</h2>
          <form onSubmit={handleSubmit}>
            <div style={rowStyle}>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>First Name *</label>
                <input
                  name="firstName"
                  type="text"
                  onChange={handleChange}
                  required
                  style={halfInputStyle}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={labelStyle}>Last Name *</label>
                <input
                  name="lastName"
                  type="text"
                  onChange={handleChange}
                  required
                  style={halfInputStyle}
                />
              </div>
            </div>

            <label style={labelStyle}>Email ID *</label>
            <input
              name="email"
              type="email"
              onChange={handleChange}
              required
              style={inputStyle}
            />

            <label style={labelStyle}>Mobile No.</label>
            <input
              name="mobile"
              type="tel"
              onChange={handleChange}
              value={formData.mobile}
              pattern="^\+\d{10,15}$"
              title="Enter a valid mobile number with country code, e.g., +919589348858"
              style={inputStyle}
            />

            <label style={labelStyle}>Token Quantity *</label>
            <input
              name="quantity"
              type="number"
              onChange={(e) => {
                const value = e.target.value;
                if (!Number.isInteger(Number(value))) {
                  return; // ignore non-integer input
                }
                handleChange(e);
              }}
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "+" ||
                  e.key === "-" ||
                  e.key === "."
                ) {
                  e.preventDefault();
                }
              }}
              required
              style={inputStyle}
            />

            <label style={labelStyle}>Telegram ID</label>
            <input
              name="telegram"
              type="text"
              onChange={handleChange}
              style={inputStyle}
            />

            <button type="submit" className="btn border" disabled={loading}>
              {loading ? <div style={spinnerStyle}></div> : "Submit"}
            </button>
          </form>
        </div>
      )}
      {/* Spinner keyframes */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default PresaleForm;
